import { SelectOptionItemType } from '@revolut-internal/ui-kit'
import {
  MultiSelectFilter,
  TableColumnInstance,
  TableData,
} from '@revolut-internal/ui-kit-table'

type CheckboxSelectFilterProps<T extends TableData> = {
  label: string
  column: TableColumnInstance<T>
  options: SelectOptionItemType<string>[]
}

export const CheckboxSelectFilter = <T extends object>({
  column,
  label,
  options,
}: CheckboxSelectFilterProps<T>) => {
  const value = column.getFilterValue() as string[] | undefined

  return (
    <MultiSelectFilter
      active={Boolean(value)}
      value={value}
      options={options}
      label={`${label} Filter`}
      labelList={`Select ${label}`}
      onChange={column.setFilterValue}
    />
  )
}
